export const styles = theme => ({
    inputField: {
        margin: "0.5rem 0"
    },
    divider: {
        margin: "2rem 0"
    },
    addressTitle: {
        marginBottom: "1rem"
    }
});
